import React from "react";
import "./Styles/portfolio.css";

function About() {
  return (
    <>
      <section className="bg-light" id="about">
        <div className="container" style={{ textAlign: "center" }}>
          <header className="mb-5">
            <p
              className="font-weight-bold text-primary text-uppercase letter-spacing-2"
              style={{ fontSize: "2rem" }}
            >
              ABOUT ME
            </p>
            <h3 className="h3 lined">If you’re wondering who I am…</h3>
          </header>
          <p className="text-muted">
            I’m Adebayo, a young self-taught Web developer, from Lagos, Nigeria.
          </p>
          <p className="text-muted">
            After my college degree in "Computer Science", I got a job as a
            "Telecommunications Engineer", where I stayed for over 3 years,
            working on related GIS (Geographical Information System) whilst
            deploying fiber optics cable in the city of Lagos, I felt stuck.
          </p>
          <p className="text-muted mb-0">
            I decided to opt my game into Web developer, and since then I have
            developed awesome applications from GIS app to Business application
          </p>
          <p className="text-muted" style={{ marginTop: "7px" }}>
            {" "}
            I also stay abreast in the{" "}
            <span className="section2">
              <span className="slanted2">BlockChain Technology </span>
            </span>{" "}
            to explode it potential for the " WEB 3.0 " revolution.
          </p>
          <br />
          <br />

          <a
            className="btn btn info2"
            href="http://bit.ly/2vjVeGW"
            target="blank"
          >
            <i className="fas fa-paper-plane"></i> Resume
          </a>
        </div>
      </section>
    </>
  );
}

export default About;
